import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Switch,
  Grid,
  Button,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Link,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LaunchIcon from "@mui/icons-material/Launch";

function CompanySetupCard({
  id,
  logo,
  title,
  offer,
  body,
  icon,
  buttonText,
  applicationUrl,
  handleOpenAccount,
}) {
  return (
    // <></>
    <Box sx={{ width: "100%", bgcolor: "#fff", p: 0 }}>
      {/* Partner Card */}
      <Card
        sx={{
          mb: 3,
          borderRadius: 2,
          p: 2,
          border: "1px solid grey",
          boxShadow: "none",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={2}>
              <CardMedia
                component="img"
                image={logo}
                alt="Kingsbridge Insurance"
                sx={{
                  objectFit: "contain",
                  maxHeight: 60,
                  backgroundColor: "#f7f7f7",
                  p: 1,
                  borderRadius: 1,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                  {title}
                </Typography>
                <Button
                  width="100%"
                  endIcon={<LaunchIcon />}
                  sx={{ borderRadius: 1, textTransform: "none", color: "blue" }}
                  onClick={() => {
                    applicationUrl
                      ? window.open(applicationUrl)
                      : handleOpenAccount(id);
                  }}
                >
                  {buttonText}
                </Button>
              </Box>
              {offer && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="subtitle2" fontWeight="550">
                    <strong>Offer:</strong> {offer}
                  </Typography>
                </Box>
              )}
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontWeight: "550",
                  maxWidth: "700px",
                  color: "black",
                }}
              >
                {body}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Box>
  );
}

export default CompanySetupCard;
